import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
import { notices, noticesImage } from '../data/homepage';

/** Same blob as the hero, mirrored, for the photo beside the notices. */
const BLOB = '46% 54% 58% 42% / 56% 44% 56% 44%';
/** Town icon, stamped over each notice image the way the Town does. */
const ICON_SRC = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/06/Bonnyville_Icon_Gold_RGB.png';
export function News() {
  return <section aria-labelledby="local-notices-title" className="bg-ville-lime" data-id="element-1625" data-mp="d211r3jl3rgn">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-1626" data-mp="hz0xakit5bti">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,32%)_minmax(0,1fr)] lg:gap-14" data-id="element-1627" data-mp="3bpk6e6z9jra">
          <div className="relative mx-auto w-full max-w-[420px]" data-id="element-1628" data-mp="8a0vktcx82bm">
            <span aria-hidden="true" className="absolute -inset-4 border-2 border-ville-navy" style={{
            borderRadius: BLOB
          }} data-id="element-1629" data-mp="88g3rbhzqxhg" />
            <img src={noticesImage} alt="" className="relative block aspect-square w-full object-cover" style={{
            borderRadius: BLOB
          }} data-id="element-1630" data-mp="10s4todneu2rt" />
          </div>

          <div className="py-4 lg:py-14" data-id="element-1631" data-mp="2squseban3wj4">
            <p className="text-center font-display text-lg font-extrabold text-ville-navy" data-id="element-1632" data-mp="37htx3b8cu0xf">Stay Connected</p>
            <h2 id="local-notices-title" className="mt-1 text-center font-display text-4xl font-extrabold tracking-tight text-ville-navy sm:text-5xl" data-id="element-1633" data-mp="32pu2zzeyu28r">
              Local Notices
            </h2>

            <ul className="mt-8 grid gap-5 sm:grid-cols-3" data-id="element-1634" data-mp="3bl9sy5clnx92">
              {notices.map(notice => <li key={notice.id} className="flex" data-id="element-1635" data-mp="3qe3m2tksobw7">
                  <article className="flex w-full flex-col overflow-hidden rounded-2xl border-2 border-ville-navy bg-ville-sand" data-id="element-1636" data-mp="3liejsihe4gw7">
                    <div className="relative h-[150px] shrink-0" data-id="element-1637" data-mp="1w2os20kr3qan">
                      <img src={notice.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-1638" data-mp="1r4dkjwhxhrvl" />
                      <span className="absolute inset-0 bg-ville-blue/70" aria-hidden="true" data-id="element-1639" data-mp="2gssoid5gr7cy" />
                      <div className="absolute inset-x-0 top-0 flex items-center gap-2 px-3 pt-3" data-id="element-1640" data-mp="2ktuj2gofqv8l">
                        <img src={ICON_SRC} alt="" aria-hidden="true" className="h-6 w-auto shrink-0" data-id="element-1641" data-mp="2pre90duhwwgd" />
                        <span className="min-w-0 leading-none" data-id="element-1642" data-mp="2usts40d44sw4">
                          <span className="block truncate font-display text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-1643" data-mp="2zqvbynid4w8n">
                            Town of Bonnyville
                          </span>
                          <span className="mt-0.5 block text-[8px] font-bold uppercase tracking-[0.14em] text-ville-lime" data-id="element-1644" data-mp="38joseo9jq1o3">
                            North of Expected
                          </span>
                        </span>
                      </div>
                      <p className="absolute inset-x-0 bottom-9 text-center text-sm font-bold text-white" data-id="element-1645" data-mp="3nfxq3ldsg6ye">
                        {notice.caption}
                      </p>
                      <span className="absolute inset-x-0 bottom-0 flex justify-center" data-id="element-1646" data-mp="1btvs95s59d1i">
                        <span className="w-4/5 bg-ville-lime py-1 text-center text-xs font-extrabold text-ville-navy" data-id="element-1647" data-mp="16rwtyab9h6bf">
                          {notice.tag}
                        </span>
                      </span>
                    </div>

                    <div className="flex flex-1 flex-col bg-white px-4 py-4" data-id="element-1648" data-mp="1uisrlo2eevql">
                      <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500" data-id="element-1649" data-mp="1ukwt5zctrinp">{notice.date}</p>
                      <h3 className="mt-2 font-display text-[17px] font-extrabold leading-snug text-ville-navy" data-id="element-1650" data-mp="1kszf8kufmcla">
                        {notice.title}
                      </h3>
                      <a href="#accueil" className="mt-auto pt-4 text-xs font-extrabold uppercase tracking-wider text-ville-blue underline-offset-4 transition-colors duration-150 ease-ville hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-1651" data-mp="1fsbq64prk5tp">
                        Read more
                      </a>
                    </div>
                  </article>
                </li>)}
            </ul>

            <p className="mt-8 text-center" data-id="element-1652" data-mp="1o1qzocf98h9w">
              <a href="#accueil" className="inline-flex items-center gap-1.5 rounded-full bg-ville-spring px-5 py-2 text-sm font-bold text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-navy focus-visible:ring-offset-2 focus-visible:ring-offset-ville-lime" data-id="element-1653" data-mp="1o2ii0ljucii8">
                <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1654" data-mp="26za8bexsvxvs" />
                Older Entries
              </a>
            </p>
          </div>
        </div>
      </div>

      <div aria-hidden="true" className="-mb-px mt-6 w-full" data-id="element-1655" data-mp="2zh5tx8g2wv1b">
        <svg viewBox="0 0 1440 140" preserveAspectRatio="none" className="block h-[64px] w-full sm:h-[110px]" data-id="element-1656" data-mp="2ziqrz81lqw3x">
          <path d="M0,92 C240,36 450,138 720,100 C990,62 1220,16 1440,68 L1440,140 L0,140 Z" fill="#063731" data-id="element-1657" data-mp="j33tesmzcu45" />
        </svg>
      </div>
    </section>;
}